// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* General Layout */
.competition-container {
  background-color: #fff;
  text-align: center;
  min-height: 100vh;
  box-sizing: border-box;
}

.view-all-button {
  border-radius: 6px !important;
}

/* Header Section */
.competition-header {
  max-width: 100%;
  margin: 0 auto 40px auto;
}

.card-icon {
  width: 40px;
  height: 40px;
}

.competition-icon {
  font-size: 40px;
  color: #2C68AD;
  margin-bottom: 20px;
}

.social-hero-graphic {
  width: 95%;
  margin: 0 auto 8px;
  display: block;
  max-width: 1200px;
  overflow: hidden;
}

.social-hero-graphic img {
  width: 100%;
  height: 200px;
  display: block;
  margin-top: 0;
  margin-bottom: -40px;
  object-fit: cover;
  object-position: center 60%;
}

.competition-title {
  font-size: 32px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-top: 8px;
  margin-bottom: 10px;
  line-height: 1.3;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.social-highlight {
  color: #0077B6;
  font-family: "opensans", sans-serif;
  line-height: 1.3;
  font-size: 36px;
  font-weight: 600;
}

.competition-subtitle {
  font-size: 16px;
  color: #6E6A6A;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  line-height: 1.6;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.hero-cta {
  margin-top: 10px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  background-color: #2C68AD;
  color: #fff;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(44, 104, 173, 0.2);
}

.hero-cta:hover {
  opacity: 0.92;
}

/* Card Section */
.competition-card-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 16px;
}

.competition-card {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.33% - 20px);
  min-width: 320px;
  max-width: 400px;
  min-height: 210px;
  border-radius: 4px;
  box-shadow: 0.2px 0.2px 1px rgba(182, 178, 178, 0.6), 1px 1px 6px rgba(182, 178, 178, 0.8) !important;
  padding: 24px 18px;
  transition: all 0.3s ease;
  background: #fff;
  border: 1px solid rgba(44, 104, 173, 0.3215686275);
}

.competition-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.card-icon-circle {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: #2C68AD;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px auto;
}

.card-icon-circle .anticon {
  color: #fff;
  font-size: 24px;
}

.social-card-title {
  font-size: 22px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-bottom: 10px;
}

.card-description {
  font-size: 15px;
  color: #000000;
  font-weight: 400;
  font-family: "opensans", sans-serif;
  line-height: 1.6;
}

.data-scope-section {
  margin: 36px auto 0 auto;
  max-width: 1500px;
  padding: 0 46px;
}
.data-scope-section .data-scope-card {
  background: #fff;
  border-radius: 12px;
  padding: 10px 8px 8px;
  box-shadow: none;
  text-align: left;
}
.data-scope-section .data-scope-card h2 {
  font-size: 22px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  text-align: center;
  margin-bottom: 14px;
}
.data-scope-section .scope-grid {
  list-style: none;
  padding: 0;
  margin: 0;
}
.data-scope-section .scope-grid li {
  display: grid;
  grid-template-columns: 210px 1fr;
  column-gap: 24px;
  position: relative;
  padding-left: 14px;
  margin: 10px 0;
  font-size: 14px;
  color: #2b2b2b;
  font-family: "opensans", sans-serif;
}
.data-scope-section .scope-grid li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 0;
  color: #2C68AD;
  font-size: 16px;
  line-height: 1.4;
}
.data-scope-section .scope-label {
  color: #2C68AD;
  font-weight: 700;
  font-size: 14px;
}
.data-scope-section .scope-text {
  color: #000000;
  font-weight: 400;
  font-size: 14px;
}
.data-scope-section .scope-emphasis {
  color: #111;
  font-weight: 600;
}
.data-scope-section .scope-note {
  margin-top: 12px;
  font-size: 14px;
  color: #8a8a8a;
  font-family: "opensans", sans-serif;
}
.data-scope-section .analysis-buttons {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 28px;
  margin-bottom: 38px;
}
.data-scope-section .analysis-card {
  text-align: center;
  background: #fff;
  border-radius: 6px;
  padding: 24px 18px;
  width: 100%;
  max-width: 600px;
  height: 300px;
  border: 2px solid #2c68ad;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.data-scope-section .analysis-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #2C68AD;
  font-size: 22px;
  width: 50px;
  height: 50px;
}
.data-scope-section .analysis-card h3 {
  font-size: 20px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin: 8px 0;
}
.data-scope-section .analysis-card p {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  font-family: "opensans", sans-serif;
  line-height: 1.5;
  margin: 0 0 12px;
}
.data-scope-section .analysis-card .button {
  margin-top: 12px;
  background-color: #2C68AD;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
}

.recent-reports {
  max-width: 1320px;
  margin: 0 auto 32px;
  padding: 0 46px 32px;
}

.recent-reports-card {
  border-radius: 10px;
  border: 1px solid #d7e2f4;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.recent-reports-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;
}

.recent-reports-title {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  font-family: "opensans", sans-serif;
  margin: 0;
}

.recent-reports-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.recent-report-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #2c68ad;
  border-radius: 6px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.recent-report-item:hover {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #2c68ad;
  border-radius: 6px;
  padding: 10px 12px;
  background: #fafafa;
  cursor: pointer;
}

.recent-report-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000000;
}

.recent-report-title {
  font-size: 14px;
  font-weight: 700;
  color: #000000;
  font-family: "Open Sans", sans-serif;
  text-align: left;
}

.recent-report-date {
  font-size: 14px;
  color: #000000;
  font-family: "Open Sans", sans-serif;
  margin-top: 2px;
}

.recent-report-empty {
  font-size: 12px;
  color: #6e6a6a;
  font-family: "opensans", sans-serif;
  padding: 6px 2px;
  text-align: center;
}

.history-page {
  padding: 24px 16px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.history-header {
  width: 100%;
  max-width: 1300px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.history-back-button {
  background-color: #2c68ad;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-weight: 600;
  height: 32px;
}

.history-heading {
  font-size: 24px;
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
  color: #000000;
  margin: 0;
  text-align: center;
  flex: 1 1;
}

.history-card {
  width: 100%;
  max-width: 1300px;
  border: 1px solid #d7e2f4;
  border-radius: 10px;
  box-shadow: none;
}

.history-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid #e6eef9;
}

.history-card-title {
  font-size: 16px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin: 0;
}

.history-actions {
  display: inline-flex;
  gap: 15px;
  margin-left: auto;
}

.history-icon-button {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: none;
  background: #fff;
  color: #2c68ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;
}

.history-icon-tooltip-trigger {
  display: inline-flex;
}

.history-delete-icon {
  width: 20px;
  height: 20px;
}

.history-list {
  display: flex;
  flex-direction: column;
}

.history-row {
  display: grid;
  grid-template-columns: 28px 1fr 44px auto;
  gap: 12px;
  padding: 12px 8px;
  border-bottom: 1px solid #e6eef9;
  align-items: flex-start;
}

.history-row:last-child {
  border-bottom: none;
}

.history-header-select {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.history-checkbox {
  width: 14px;
  height: 14px;
  border: 1px solid #c9d7ee;
  border-radius: 3px;
  appearance: none;
  background: #fff;
  display: inline-block;
}

.history-checkbox:checked {
  background: #2c68ad;
  border-color: #2c68ad;
  position: relative;
}

.history-checkbox:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.history-title-row {
  display: block;
  margin-bottom: 6px;
}

.history-item-title {
  font-size: 24px;
  font-weight: 700;
  color: #2c68ad;
  font-family: "Open Sans", sans-serif;
  line-height: 1.15;
}

.history-item-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.history-author {
  font-size: 13px;
  color: #8a8a8a;
  font-family: "opensans", sans-serif;
  margin-top: 2px;
}

.history-badge {
  background: #f1f3f5;
  color: #9ca3af;
  font-size: 10px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 999px;
}

.history-date {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 400;
  font-family: "opensans", sans-serif;
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.history-status-success {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #36b25b;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.history-status-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.history-row > .history-checkbox {
  margin-top: 34px;
}

.history-row .history-view-button {
  align-self: center;
}

.history-view-button {
  background-color: #2c68ad;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  height: 28px;
}

.brand-form-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center children horizontally */
  margin-top: 48px;
  padding: 0 16px;
  text-align: center;
  position: relative;
}

.brand-form-header {
  width: 100%;
  max-width: 900px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;
  align-self: flex-start;
  margin-top: -40px;
}

.brand-back-button {
  background-color: #2C68AD;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-weight: 600;
  height: 32px;
  margin-right: 5px;
  margin-bottom: 2px;
}

.brand-back-button:hover {
  opacity: 0.9;
  background-color: #2a73c2;
}

.brand-form-title {
  font-size: 36px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-bottom: 8px;
  line-height: 1.3;
  max-width: 720px;
}

.brand-form-subtitle {
  font-size: 16px;
  font-weight: 400;
  color: #6E6A6A;
  font-family: "opensans", sans-serif;
  line-height: 1.6;
  text-align: center;
  max-width: 520px;
  margin-bottom: 18px;
}

.brand-form-card {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  box-shadow: 0.5px 0.5px 2px rgba(182, 178, 178, 0.6), 2px 2px 6px rgba(182, 178, 178, 0.8) !important;
  border-radius: 8px;
}

.brand-form-label {
  font-size: 12px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #111;
  margin-bottom: 20px;
  margin-top: 10px;
}

.brand-form-label .ant-form-item-label > label {
  font-weight: 600;
  color: #111;
  font-size: 12px;
}

.brand-form-card .ant-form-item-label > label {
  font-weight: 700;
  color: #000000;
  font-size: 10px;
}

.brand-placeholder {
  font-size: 10px;
  color: #6E6A6A;
  font-family: "opensans", sans-serif;
  padding: 10px;
}

.brand-form-note {
  font-size: 12px;
  font-weight: 400;
  color: #6E6A6A;
  font-family: "opensans", sans-serif;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: left;
}

.brand-form-buttons {
  display: flex;
  justify-content: center;
}

.brand-form-buttons .button--primary {
  width: 100%;
  max-width: 260px;
  height: 36px;
  border-radius: 6px;
  background-color: #2C68AD !important;
}

.start-btn {
  background: linear-gradient(90deg, #7c3aed, #a78bfa);
  border: none;
  color: #fff;
  transition: 0.3s ease;
}

.start-btn:hover {
  opacity: 0.9;
}

.competitive-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 48px;
  padding: 0 16px 40px;
  text-align: center;
}

.competitive-form-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  align-self: stretch;
  margin-top: -40px;
}

.competitive-form-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.competitive-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #c7d7ee;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  cursor: default;
}

.competitive-form-title {
  font-size: 36px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin: 0;
  line-height: 1.3;
}

.competitive-form-subtitle {
  font-size: 16px;
  font-weight: 400;
  color: #6E6A6A;
  font-family: "opensans", sans-serif;
  line-height: 1.6;
  text-align: center;
  max-width: 520px;
  margin-bottom: 18px;
}

.competitive-form {
  width: 100%;
  max-width: 980px;
}

.competitor-grid {
  display: grid;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  gap: 18px;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  align-items: start;
}

.competitive-form-card {
  width: 100%;
  background: #fff;
  padding: 16px 16px 8px;
  border-radius: 6px;
  box-shadow: 0.2px 0.2px 1px rgba(182, 178, 178, 0.6), 1px 1px 6px rgba(182, 178, 178, 0.8) !important;
  text-align: left;
}

.Brand-back-button {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-bottom: 2px;
}

.competitive-form-card h3 {
  font-size: 13px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #A6A6A6;
  margin-bottom: 10px;
  margin-top: -10px;
}

.competitive-form-card .brand-form-label {
  font-size: 12px;
  margin-bottom: 10px;
}

.competitive-form-card .ant-form-item {
  margin-bottom: 10px;
}

.competitor-note {
  font-size: 11px;
  color: #9a9a9a;
  margin-top: 4px;
}

.competitive-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.add-competitor-box {
  width: 100%;
  max-width: 350px;
  border: 1px dashed #9fb6d7 !important;
  color: #2C68AD !important;
  background: #fff !important;
  border-radius: 6px;
  height: 32px;
  font-size: 12px;
  font-weight: 600;
}

.add-competitor-box:hover {
  background: #f1f6ff !important;
}

.social-icon {
  width: 36px;
  height: 36px;
}

.report-container {
  padding: 12px 8px 32px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.report-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  min-width: 0;
}

.report-back-button {
  background-color: #2C68AD;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-weight: 600;
  height: 32px;
  justify-content: left;
}

.report-back-button:hover {
  opacity: 0.9;
}

.report-title {
  font-size: 26px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin: 0;
  flex: 1 1;
  text-align: center;
}

.report-card {
  width: 100%;
  min-width: 0;
  border: 1px solid rgba(44, 104, 173, 0.2);
  border-radius: 8px;
  box-shadow: none;
}
.report-card .ant-card-body {
  padding: 20px 22px;
}

.report-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 2px solid #e6eef9;
}

.report-card-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #2C68AD;
  font-family: "opensans", sans-serif;
}

.report-actions {
  display: inline-flex;
  gap: 16px;
}

.report-icon-button {
  width: 26px;
  height: 26px;
  border-radius: 4px;
  border: none;
  background: #fff;
  color: #2C68AD;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.report-icon {
  width: 20px;
  height: 20px;
}

.report-section {
  border: 1px solid #e6eef9;
  border-radius: 6px;
  padding: 16px 18px;
  margin-bottom: 12px;
  background: #fff;
}

.report-section-sources {
  padding: 24px 20px 32px;
}

.report-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #000000;
  font-family: "opensans", sans-serif;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sentiment-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sentiment-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #2C68AD;
  color: #2C68AD;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sentiment-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 8px;
}

.sentiment-stat {
  text-align: center;
}

.sentiment-value {
  font-size: 20px;
  font-weight: 800;
  color: #000000;
  display: block;
}

.sentiment-inline-pct {
  font-size: 14px;
  font-weight: 700;
  margin-left: 4px;
}

.sentiment-label {
  font-size: 12px;
  font-weight: 400;
  color: #6E6A6A;
  display: block;
  margin-top: 2px;
}

.sentiment-total .sentiment-value {
  color: #000000;
}

.sentiment-sublabel {
  font-size: 11px;
  color: #6e6a6a;
  margin-top: 2px;
  font-family: "opensans", sans-serif;
}

.sentiment-positive .sentiment-value,
.sentiment-positive .sentiment-inline-pct {
  color: #2e7d32;
}

.sentiment-neutral .sentiment-value,
.sentiment-neutral .sentiment-inline-pct {
  color: #f9a825;
}

.sentiment-negative .sentiment-value,
.sentiment-negative .sentiment-inline-pct {
  color: #d32f2f;
}

.sentiment-bar {
  display: flex;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: #e6eef9;
  width: 100%;
  margin-top: 4px;
}

.sentiment-segment {
  height: 100%;
  display: block;
  min-width: 6px;
}

.sentiment-segment.positive {
  background: #37A751;
}

.sentiment-segment.neutral {
  background: #FFBA03;
}

.sentiment-segment.negative {
  background: #FF0000;
}

.source-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.source-list-empty,
.report-section-empty {
  margin: 0;
  font-size: 13px;
  color: #6e6a6a;
  font-family: "opensans", sans-serif;
}

.source-accordion {
  border-bottom: 1px solid #e6eef9;
}
.source-accordion.is-expanded {
  background: #fff;
}

.source-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  background: transparent;
  min-height: 86px;
  padding: 16px 0 16px 22px;
  cursor: pointer;
  text-align: left;
  gap: 24px;
}

.source-platform {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  min-width: 74px;
  gap: 0;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-left: 0;
}

.source-platform img {
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.source-platform > span:not(.source-reddit-icon) {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.source-reddit-icon {
  width: 46px;
  height: 46px;
  border-radius: 6px;
  background: #ff4500;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  line-height: 1;
}

.source-metrics {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 34px;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  margin-right: 0;
  margin-left: auto;
  white-space: nowrap;
}

.source-metrics .positive {
  color: #37A751;
  font-weight: 500;
}

.source-metrics .negative {
  color: #FF0000;
  font-weight: 500;
}

.source-chevron {
  color: #707a85;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  margin-right: 0;
}
.source-chevron.is-open {
  transform: rotate(180deg);
}

.source-posts-panel {
  margin: 0 0 34px;
  padding: 24px 26px 26px;
  border: none;
  border-radius: 8px;
  background: #f8fafc;
}

.source-posts-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
}
.source-posts-panel-header h4 {
  margin: 0;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 700;
  color: #2f3a4c;
  font-family: "opensans", sans-serif;
}

.source-posts-search {
  width: 100%;
  max-width: 280px;
  height: 36px;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
}

.source-posts-search-icon {
  width: 15px;
  height: 15px;
  opacity: 0.6;
}

.source-posts-empty {
  margin: 0;
  font-size: 13px;
  color: #6e6a6a;
}

.source-posts-table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e8eef6;
  border-radius: 6px;
}

.source-posts-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "opensans", sans-serif;
  table-layout: fixed;
}
.source-posts-table tbody {
  align-items: initial;
  justify-content: initial;
}
.source-posts-table tr {
  width: 100%;
  background: #fff !important;
  border-radius: 0;
}
.source-posts-table tbody tr:nth-child(odd),
.source-posts-table tbody tr:nth-child(even) {
  background: #fff !important;
}
.source-posts-table tbody tr:not(:last-child) {
  border-bottom: 1px solid #edf2f8 !important;
}
.source-posts-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #728096;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 18px 22px;
  border-bottom: 1px solid #edf2f8 !important;
}
.source-posts-table th:nth-child(1),
.source-posts-table td:nth-child(1) {
  width: 40%;
}
.source-posts-table th:nth-child(2),
.source-posts-table td:nth-child(2) {
  width: 15%;
}
.source-posts-table th:nth-child(3),
.source-posts-table td:nth-child(3) {
  width: 27%;
}
.source-posts-table th:nth-child(4),
.source-posts-table td:nth-child(4) {
  width: 18%;
  vertical-align: middle;
  text-align: center !important;
}
.source-posts-table td {
  text-align: left !important;
  font-size: 13px;
  color: #2f3a4c;
  padding: 21px 22px;
  border-bottom: 1px solid #edf2f8;
  vertical-align: top;
  word-break: break-word;
  background: #fff !important;
}
.source-posts-table tbody tr:last-child td {
  border-bottom: none !important;
}

.source-post-details a {
  display: inline-block;
  text-align: left;
  color: #2f74ff;
  text-decoration: none;
  font-weight: 700;
  line-height: 1.55;
}
.source-post-details a:hover {
  text-decoration: underline;
}

.source-post-type {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  background: #eef4ff;
  color: #2c68ad;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.source-post-comments-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
}

.source-post-comment {
  display: block;
  color: #2f3a4c;
  line-height: 1.4;
}

.source-post-engagement-inner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #2f3a4c;
  font-weight: 600;
  white-space: nowrap;
}
.source-post-engagement-inner svg {
  color: #e53935;
  flex-shrink: 0;
}

.source-post-likes-value {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  color: #2f3a4c;
}

.source-post-likes-label {
  color: #96a1b2;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.source-posts-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 22px;
  margin-top: 0;
  font-size: 12px;
  color: #728096;
  background: #fff;
}

.source-posts-pagination-summary {
  margin-right: auto;
  font-size: 11px;
}
.source-posts-pagination-summary strong {
  font-weight: 700;
  color: #445066;
}

.source-posts-pagination-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.source-posts-page-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 4px;
  background: #fff;
  color: #445066;
  font-size: 12px;
  font-weight: 700;
}

.source-posts-page-btn {
  border: 1px solid #d5e3f5;
  background: #fff;
  color: #2c68ad;
  border-radius: 8px;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.source-posts-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.report-summary-box {
  background: #f4f8ff;
  border: 1px solid #e6eef9;
  border-left: 4px solid #2c68ad;
  border-radius: 4px;
  padding: 14px 16px;
}
.report-summary-box p {
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.6;
  color: #111;
  font-family: "opensans", sans-serif;
}
.report-summary-box p:last-child {
  margin-bottom: 0;
}

.report-highlights-list {
  list-style: none;
  margin: 0;
  padding: 14px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.report-highlight-item {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #f5faff;
  border: 1px solid #d8eaff;
  border-radius: 8px;
  padding: 17px 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #53647a;
  font-family: "opensans", sans-serif;
}

.report-highlight-arrow {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #e3f1ff;
  color: #2f7bd7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.report-highlight-content {
  flex: 1 1;
  min-width: 0;
  color: #53647a;
}

.report-markdown {
  font-size: 13px;
  line-height: 1.55;
  color: #111;
  font-family: "opensans", sans-serif;
}
.report-markdown p,
.report-markdown .report-markdown-paragraph {
  margin: 0 0 8px;
}
.report-markdown p:last-child,
.report-markdown .report-markdown-paragraph:last-child {
  margin-bottom: 0;
}
.report-markdown .report-markdown-heading {
  margin: 10px 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: #2c68ad;
  font-family: "opensans", sans-serif;
}
.report-markdown .report-markdown-heading:first-child {
  margin-top: 0;
}
.report-markdown .report-markdown-list {
  margin: 0 0 8px;
  padding-left: 18px;
}
.report-markdown .report-markdown-list:last-child {
  margin-bottom: 0;
}
.report-markdown .report-markdown-list-item {
  margin-bottom: 4px;
}
.report-markdown strong {
  font-weight: 700;
  color: #111;
}

.report-markdown-link {
  color: #2c68ad;
  font-weight: 600;
  text-decoration: underline;
}

.report-summary-box .report-markdown .report-markdown-heading {
  font-size: 12px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.report-highlight-content .report-markdown p {
  display: inline;
  margin: 0;
}

.report-highlight-content .report-markdown {
  color: #53647a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.55;
}

.report-actions-list .report-markdown p {
  display: inline;
  margin: 0;
}

.report-actions-list {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.6;
  color: #111;
  font-family: "opensans", sans-serif;
}
.report-actions-list li {
  margin-bottom: 8px;
}
.report-actions-list li:last-child {
  margin-bottom: 0;
}

.report-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: #2c68ad;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .report-section-sources {
    padding: 18px 12px 24px;
  }
  .source-row {
    padding-left: 0;
    gap: 12px;
  }
  .source-platform {
    width: 58px;
    min-width: 58px;
  }
  .source-platform img,
  .source-reddit-icon {
    width: 38px;
    height: 38px;
  }
  .source-reddit-icon {
    font-size: 28px;
  }
  .source-metrics {
    gap: 12px;
    font-size: 13px;
    flex-wrap: wrap;
  }
  .source-posts-panel {
    padding: 18px 14px;
  }
  .source-posts-panel-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .source-posts-search {
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/SocialListingAgent/SocialListingAgent.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,mBAAA;AACA;EACE,sBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAEA;EACE,6BAAA;AACF;;AACA,mBAAA;AACA;EACE,eAAA;EACA,wBAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;AAGF;;AADA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAIF;;AAFA;EACE,UAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAFA;EACI,WAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,2BAAA;AAKJ;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,cAAA;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;EACF,gBAAA;AAKF;;AAFA;EACE,eAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AAMF;;AAHA;EACE,aAAA;AAMF;;AAHA,iBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAMF;;AAHA;EACE,YAAA;EAAA,cAAA;EAAA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qGAAA;EAEA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kDAAA;AAKF;;AAFA;EACE,2BAAA;EACA,yCAAA;AAKF;;AADA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AAIF;;AADA;EACE,WAAA;EACA,eAAA;AAIF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;AAIF;;AADA;EACE,eAAA;EACE,cAAA;EACA,gBAAA;EACF,mCAAA;EACA,gBAAA;AAIF;;AAFA;EACE,wBAAA;EACA,iBAAA;EACA,eAAA;AAKF;AAHE;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAKJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAIJ;AADE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAGJ;AAAE;EACE,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,mCAAA;AAEJ;AACE;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAIE;EACE,WAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mCAAA;AAHJ;AAME;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACF,kBAAA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AALJ;AAQE;EAGE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACE,WAAA;EACF,YAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,aAAA;AATJ;AAYE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAXJ;;AAeA;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;AAZF;;AAgBA;EACE,mBAAA;EACA,yBAAA;EACA,yCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,SAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBC5UiB;ED6UjB,eAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cChVU;ADmUZ;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cCtVU;EDuVV,oCCtJY;EDuJZ,gBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cC7VU;ED8VV,oCC7JY;ED8JZ,eAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAbF;;AAiBA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,oCCvMY;EDwMZ,cCzYU;ED0YV,SAAA;EACA,kBAAA;EACA,SAAA;AAdF;;AAiBA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAdF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,SAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,SAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,oBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,yCAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,cCphBc;EDqhBd,oCChUY;EDiUZ,iBAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,cCvhBW;EDwhBX,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cChiBW;EDiiBX,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAdF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA,EAAA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACE,iBAAA;EACA,kBAAA;AAjBJ;;AAoBA;EACE,YAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACI,mCAAA;EACJ,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACC,qGACC;EAEF,kBAAA;AAnBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAlBF;;AAoBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAjBF;;AAmBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAhBF;;AAkBA;EACI,eAAA;EACF,cAAA;EACA,mCAAA;EACA,aAAA;AAfF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AAdF;;AAiBA;EACE,oDAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAjBF;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,2DAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qGAAA;EAEA,gBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACI,iBAAA;EACF,kBAAA;AAnBJ;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,8BAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;AAlBF;;AAsBA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,YAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AAnBF;AAqBE;EACE,kBAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;AApBF;;AAuBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AApBF;;AAuBA;EACE,oBAAA;EACA,SAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AApBF;;AAsBA;EACE,WAAA;EACA,YAAA;AAnBF;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;AAlBF;;AAqBA;;EAEE,cAAA;AAlBF;;AAqBA;;EAEE,cAAA;AAlBF;;AAqBA;;EAEE,cAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAlBF;;AAqBA;;EAEE,SAAA;EACA,eAAA;EACA,cAAA;EACA,mCAAA;AAlBF;;AAqBA;EACE,gCAAA;AAlBF;AAoBE;EACE,gBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AAnBF;AAqBE;EACE,yBAAA;AAnBJ;;AAuBA;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AApBF;AAsBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AArBF;;AAwBA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;AArBF;AAuBE;EACE,oBAAA;EACA,wBAAA;AArBJ;AAwBE;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AAtBJ;AAyBE;;EAEE,2BAAA;AAvBJ;AA0BE;EACE,2CAAA;AAxBJ;AA2BE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;AAzBJ;AA4BE;;EAEE,UAAA;AA1BJ;AA6BE;;EAEE,UAAA;AA3BJ;AA8BE;;EAEE,UAAA;AA5BJ;AA+BE;;EAEE,UAAA;EACA,sBAAA;EACA,6BAAA;AA7BJ;AAgCE;EACE,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;AA9BJ;AAiCE;EACE,8BAAA;AA/BJ;;AAmCA;EACE,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AAhCF;AAkCE;EACE,0BAAA;AAhCJ;;AAoCA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjCF;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AArCF;;AAwCA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AArCF;;AA4CA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAzCF;AA2CE;EACE,cAAA;EACA,cAAA;AAzCJ;;AA6CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA1CF;;AA6CA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,eAAA;AA1CF;AA4CE;EACE,gBAAA;EACA,cAAA;AA1CJ;;AA8CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA3CF;;AA8CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3CF;AA6CE;EACE,aAAA;EACA,mBAAA;AA3CJ;;AA+CA;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AA5CF;AA8CE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mCAAA;AA5CJ;AA8CI;EACE,gBAAA;AA5CN;;AAiDA;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AA9CF;;AAiDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,SAAA;EACA,YAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mCAAA;AA9CF;AAgDE;;EAEE,eAAA;AA9CJ;AAgDI;;EACE,gBAAA;AA7CN;AAiDE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AA/CJ;AAiDI;EACE,aAAA;AA/CN;AAmDE;EACE,eAAA;EACA,kBAAA;AAjDJ;AAmDI;EACE,gBAAA;AAjDN;AAqDE;EACE,kBAAA;AAnDJ;AAsDE;EACE,gBAAA;EACA,WAAA;AApDJ;;AAwDA;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AArDF;;AAwDA;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;AArDF;;AAwDA;EACE,eAAA;EACA,SAAA;AArDF;;AAwDA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDF;;AAwDA;EACE,eAAA;EACA,SAAA;AArDF;;AAwDA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mCAAA;AArDF;AAuDE;EACE,kBAAA;AArDJ;AAuDI;EACE,gBAAA;AArDN;;AA0DA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAvDF;;AA0DA;EACE;IACE,uBAAA;EAvDF;EA0DA;IACE,eAAA;IACA,SAAA;EAxDF;EA2DA;IACE,WAAA;IACA,eAAA;EAzDF;EA4DA;;IAEE,WAAA;IACA,YAAA;EA1DF;EA6DA;IACE,eAAA;EA3DF;EA8DA;IACE,SAAA;IACA,eAAA;IACA,eAAA;EA5DF;EA+DA;IACE,kBAAA;EA7DF;EAgEA;IACE,uBAAA;IACA,sBAAA;EA9DF;EAiEA;IACE,eAAA;EA/DF;AACF","sourcesContent":["@import '../../styles/variables.scss';\r\n/* General Layout */\r\n.competition-container {\r\n  background-color: #fff;\r\n // padding: 20px;\r\n  text-align: center;\r\n  min-height: 100vh;\r\n  box-sizing: border-box;\r\n}\r\n.view-all-button{\r\n  border-radius: 6px !important;\r\n}\r\n/* Header Section */\r\n.competition-header {\r\n  max-width: 100%;\r\n  margin: 0 auto 40px auto;\r\n}\r\n.card-icon{\r\n  width:40px;\r\n  height:40px;\r\n}\r\n.competition-icon {\r\n  font-size: 40px;\r\n  color: #2C68AD;\r\n  margin-bottom: 20px;\r\n}\r\n.social-hero-graphic {\r\n  width: 95%;\r\n  margin: 0 auto 8px;\r\n  display: block;\r\n  max-width: 1200px;\r\n  overflow: hidden;\r\n}\r\n\r\n.social-hero-graphic img {\r\n    width: 100%;\r\n    height: 200px;\r\n    display: block;\r\n    margin-top: 0;\r\n    margin-bottom: -40px;\r\n    object-fit: cover;\r\n    object-position: center 60%;\r\n}\r\n\r\n.competition-title {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #000000;\r\n  margin-top: 8px;\r\n  margin-bottom: 10px;\r\n  line-height: 1.3;\r\n  max-width: 900px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.social-highlight {\r\n  color: #0077B6;\r\n    font-family: 'opensans', sans-serif;\r\n    line-height: 1.3;\r\n    font-size: 36px;\r\n  font-weight: 600;\r\n}\r\n\r\n.competition-subtitle {\r\n  font-size: 16px;\r\n  color: #6E6A6A;\r\n  font-family: 'opensans', sans-serif;\r\n  font-weight: 400;\r\n  line-height: 1.6;\r\n  max-width: 900px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.hero-cta {\r\n  margin-top: 10px;\r\n  max-width: 900px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background-color: #2C68AD;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 18px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 6px rgba(44, 104, 173, 0.2);\r\n}\r\n\r\n.hero-cta:hover {\r\n  opacity: 0.92;\r\n}\r\n\r\n/* Card Section */\r\n.competition-card-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 20px; \r\n  max-width: 1500px; \r\n  margin: 0 auto;\r\n  padding: 0 16px; \r\n}\r\n\r\n.competition-card {\r\n  flex: 1 1 calc(33.33% - 20px);\r\n  min-width: 320px;\r\n  max-width: 400px;\r\n  min-height: 210px;\r\n  border-radius: 4px;\r\n  box-shadow: 0.2px 0.2px 1px rgba(182, 178, 178, 0.6),\r\n   1px 1px 6px rgba(182, 178, 178, 0.8) !important;\r\n  padding: 24px 18px;\r\n  transition: all 0.3s ease;\r\n  background: #fff;\r\n  border: 1px solid #2C68AD52;\r\n}\r\n\r\n.competition-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.card-icon-circle {\r\n  width: 66px;\r\n  height: 66px;\r\n  border-radius: 50%;\r\n  background: #2C68AD;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 14px auto;\r\n}\r\n\r\n.card-icon-circle .anticon {\r\n  color: #fff;\r\n  font-size: 24px;\r\n}\r\n\r\n.social-card-title {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #000000;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.card-description {\r\n  font-size: 15px;\r\n    color: #000000;\r\n    font-weight: 400;\r\n  font-family: 'opensans', sans-serif;\r\n  line-height: 1.6;\r\n}\r\n.data-scope-section {\r\n  margin: 36px auto 0 auto;\r\n  max-width: 1500px;\r\n  padding: 0 46px;\r\n\r\n  .data-scope-card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 10px 8px 8px;\r\n    box-shadow: none;\r\n    text-align: left;\r\n  }\r\n\r\n  .data-scope-card h2 {\r\n    font-size: 22px;\r\n    font-weight: 700;\r\n    font-family: 'opensans', sans-serif;\r\n    color: #000000;\r\n    text-align: center;\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  .scope-grid {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  .scope-grid li {\r\n    display: grid;\r\n    grid-template-columns: 210px 1fr;\r\n    column-gap: 24px;\r\n    position: relative;\r\n    padding-left: 14px;\r\n    margin: 10px 0;\r\n    font-size: 14px;\r\n    color: #2b2b2b;\r\n    font-family: 'opensans', sans-serif;\r\n  }\r\n\r\n  .scope-grid li::before {\r\n    content: \"•\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    color: #2C68AD;\r\n    font-size: 16px;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .scope-label {\r\n    color: #2C68AD;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .scope-text {\r\n    color: #000000;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .scope-emphasis {\r\n    color: #111;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .scope-note {\r\n    margin-top: 12px;\r\n    font-size: 14px;\r\n    color: #8a8a8a;\r\n    font-family: 'opensans', sans-serif;\r\n  }\r\n\r\n  .analysis-buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 24px;\r\n    margin-top: 28px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .analysis-card {\r\ntext-align: center;\r\n    background: #fff;\r\n    border-radius: 6px;\r\n    padding: 24px 18px;\r\n    width: 100%;\r\n    max-width: 600px;\r\n    height: 300px;\r\n    border: 2px solid #2c68ad;\r\n    box-shadow: none;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .analysis-icon {\r\n   // width: 54px;\r\n   // height: 54px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 8px;\r\n    color: #2C68AD;\r\n    font-size: 22px;\r\n      width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .analysis-card h3 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    font-family: 'opensans', sans-serif;\r\n    color: #000000;\r\n    margin: 8px 0;\r\n  }\r\n\r\n  .analysis-card p {\r\n    font-size: 14px;\r\n    color: #000000;\r\n    font-weight: 400;\r\n    font-family: 'opensans', sans-serif;\r\n    line-height: 1.5;\r\n    margin: 0 0 12px;\r\n  }\r\n\r\n  .analysis-card .button {\r\n    margin-top: 12px;\r\n    background-color: #2C68AD;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    }\r\n}\r\n\r\n.recent-reports {\r\n  max-width: 1320px;\r\n  margin: 0 auto 32px;\r\n  padding: 0 46px 32px;\r\n  \r\n}\r\n\r\n.recent-reports-card {\r\n  border-radius: 10px;\r\n  border: 1px solid #d7e2f4;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.recent-reports-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 6px;\r\n}\r\n\r\n.recent-reports-title {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #000000;\r\n  font-family: \"opensans\", sans-serif;\r\n  margin: 0;\r\n}\r\n\r\n.recent-reports-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.recent-report-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: 1px solid $brand-primary;\r\n  border-radius: 6px;\r\n  padding: 10px 12px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.recent-report-item:hover {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: 1px solid $brand-primary;\r\n  border-radius: 6px;\r\n  padding: 10px 12px;\r\n  background: $background-light;\r\n  cursor: pointer;\r\n}\r\n\r\n.recent-report-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 6px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: $text-dark\r\n}\r\n\r\n.recent-report-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: $text-dark;\r\n  font-family: $font-family;\r\n  text-align: left;\r\n}\r\n\r\n.recent-report-date {\r\n  font-size: 14px;\r\n  color: $text-dark;\r\n  font-family: $font-family;\r\n  margin-top: 2px;\r\n}\r\n\r\n.recent-report-empty {\r\n  font-size: 12px;\r\n  color: #6e6a6a;\r\n  font-family: \"opensans\", sans-serif;\r\n  padding: 6px 2px;\r\n  text-align: center;\r\n}\r\n\r\n// history page\r\n.history-page {\r\n  padding: 24px 16px 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.history-header {\r\n  width: 100%;\r\n  max-width: 1300px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.history-back-button {\r\n  background-color: #2c68ad;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  font-weight: 600;\r\n  height: 32px;\r\n}\r\n\r\n.history-heading {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  font-family: $font-family;\r\n  color: $text-dark;\r\n  margin: 0;\r\n  text-align: center;\r\n  flex: 1;\r\n}\r\n\r\n.history-card {\r\n  width: 100%;\r\n  max-width: 1300px;\r\n  border: 1px solid #d7e2f4;\r\n  border-radius: 10px;\r\n  box-shadow: none;\r\n}\r\n\r\n.history-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 6px;\r\n  border-bottom: 1px solid #e6eef9;\r\n}\r\n\r\n.history-card-title {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  font-family: \"opensans\", sans-serif;\r\n  color: #000000;\r\n  margin: 0;\r\n}\r\n\r\n.history-actions {\r\n  display: inline-flex;\r\n  gap: 15px;\r\n  margin-left: auto;\r\n}\r\n\r\n.history-icon-button {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 6px;\r\n  border: none;\r\n  background: #fff;\r\n  color: #2c68ad;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.history-icon-tooltip-trigger {\r\n  display: inline-flex;\r\n}\r\n\r\n.history-delete-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.history-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.history-row {\r\n  display: grid;\r\n  grid-template-columns: 28px 1fr 44px auto;\r\n  gap: 12px;\r\n  padding: 12px 8px;\r\n  border-bottom: 1px solid #e6eef9;\r\n  align-items: flex-start;\r\n}\r\n\r\n.history-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.history-header-select {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin-left: 8px;\r\n}\r\n\r\n.history-checkbox {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 1px solid #c9d7ee;\r\n  border-radius: 3px;\r\n  appearance: none;\r\n  background: #fff;\r\n  display: inline-block;\r\n}\r\n\r\n.history-checkbox:checked {\r\n  background: #2c68ad;\r\n  border-color: #2c68ad;\r\n  position: relative;\r\n}\r\n\r\n.history-checkbox:checked::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 4px;\r\n  top: 1px;\r\n  width: 4px;\r\n  height: 8px;\r\n  border: solid #fff;\r\n  border-width: 0 2px 2px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.history-title-row {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.history-item-title {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: $brand-primary;\r\n  font-family: $font-family;\r\n  line-height: 1.15;\r\n}\r\n\r\n.history-item-title-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.history-author {\r\n  font-size: 13px;\r\n  color: #8a8a8a;\r\n  font-family: \"opensans\", sans-serif;\r\n  margin-top: 2px;\r\n}\r\n\r\n.history-badge {\r\n  background: #f1f3f5;\r\n  color: $text-muted;\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.history-date {\r\n  font-size: 11px;\r\n  color: $text-muted;\r\n  font-weight: 400;\r\n  font-family: \"opensans\", sans-serif;\r\n  margin-top: 4px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.history-status-success {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: #36b25b;\r\n  color: #ffffff;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.history-status-cell {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  align-self: center;\r\n}\r\n\r\n.history-row > .history-checkbox {\r\n  margin-top: 34px;\r\n}\r\n\r\n.history-row .history-view-button {\r\n  align-self: center;\r\n}\r\n\r\n.history-view-button {\r\n  background-color: #2c68ad;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  height: 28px;\r\n}\r\n\r\n\r\n\r\n// brand analysis\r\n.brand-form-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; /* Center children horizontally */\r\n  margin-top: 48px;\r\n  padding: 0 16px;\r\n  text-align: center;\r\n  position: relative;\r\n}\r\n\r\n.brand-form-header {\r\n  width: 100%;\r\n  max-width: 900px;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  margin-bottom: 6px;\r\n  align-self: flex-start;\r\n  margin-top: -40px;\r\n}\r\n\r\n.brand-back-button {\r\n  background-color: #2C68AD;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  font-weight: 600;\r\n  height: 32px;\r\n    margin-right: 5px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.brand-back-button:hover {\r\n  opacity: 0.9;\r\n  background-color: #2a73c2;\r\n}\r\n\r\n.brand-form-title {\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n      font-family: 'opensans', sans-serif;\r\n  color: #000000;\r\n  margin-bottom: 8px;\r\n  line-height: 1.3;\r\n  max-width: 720px;\r\n}\r\n\r\n.brand-form-subtitle {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  color: #6E6A6A;\r\n  font-family: 'opensans', sans-serif;\r\n  line-height: 1.6;\r\n  text-align: center;\r\n  max-width: 520px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.brand-form-card {\r\n  width: 100%;\r\n  max-width: 420px;\r\n  margin: 0 auto;\r\n   box-shadow: \r\n    0.5px 0.5px 2px rgba(182, 178, 178, 0.6),\r\n    2px 2px 6px rgba(182, 178, 178, 0.8) !important;\r\n  border-radius: 8px;\r\n}\r\n.brand-form-label{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #111;\r\n  margin-bottom: 20px;\r\n  margin-top: 10px;\r\n}\r\n.brand-form-label .ant-form-item-label > label {\r\n  font-weight: 600;\r\n  color: #111;\r\n  font-size: 12px;\r\n}\r\n.brand-form-card .ant-form-item-label > label {\r\n  font-weight: 700;\r\n  color: #000000;\r\n  font-size: 10px;\r\n}\r\n.brand-placeholder{\r\n    font-size: 10px;\r\n  color: #6E6A6A;\r\n  font-family: 'opensans', sans-serif;\r\n  padding: 10px;\r\n}\r\n.brand-form-note {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: #6E6A6A;\r\n  font-family: 'opensans', sans-serif;\r\n  line-height: 1.6;\r\n  margin-bottom: 20px;\r\n  text-align: left;\r\n}\r\n\r\n.brand-form-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.brand-form-buttons .button--primary {\r\n  width: 100%;\r\n  max-width: 260px;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n  background-color: #2C68AD !important;\r\n}\r\n\r\n.start-btn {\r\n  background: linear-gradient(90deg, #7c3aed, #a78bfa);\r\n  border: none;\r\n  color: #fff;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.start-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n\r\n//competitive analysis\r\n\r\n.competitive-form-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-top: 48px;\r\n  padding: 0 16px 40px;\r\n  text-align: center;\r\n}\r\n\r\n.competitive-form-header {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  margin-bottom: 8px;\r\n  align-self: stretch;\r\n  margin-top: -40px;\r\n}\r\n\r\n\r\n.competitive-form-title-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.competitive-info-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: #c7d7ee;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  cursor: default;\r\n}\r\n\r\n.competitive-form-title {\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #000000;\r\n  margin: 0;\r\n  line-height: 1.3;\r\n}\r\n\r\n.competitive-form-subtitle {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  color: #6E6A6A;\r\n  font-family: 'opensans', sans-serif;\r\n  line-height: 1.6;\r\n  text-align: center;\r\n  max-width: 520px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.competitive-form {\r\n  width: 100%;\r\n  max-width: 980px;\r\n}\r\n\r\n.competitor-grid {\r\n  display: grid;\r\n  width: 100%;\r\n  max-width: 980px;\r\n  margin: 0 auto;\r\n  gap: 18px;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  align-items: start;\r\n}\r\n\r\n.competitive-form-card {\r\n  width: 100%;\r\n  background: #fff;\r\n  padding: 16px 16px 8px;\r\n  border-radius: 6px;\r\n  box-shadow: 0.2px 0.2px 1px rgba(182, 178, 178, 0.6), \r\n  1px 1px 6px rgba(182, 178, 178, 0.8) !important;\r\n  text-align: left;\r\n}\r\n\r\n.Brand-back-button{\r\n  width:15px;\r\n  height:15px;\r\n      margin-right: 5px;\r\n    margin-bottom: 2px;\r\n}\r\n.competitive-form-card h3 {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #A6A6A6;\r\n  margin-bottom: 10px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.competitive-form-card .brand-form-label {\r\n  font-size: 12px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.competitive-form-card .ant-form-item {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.competitor-note {\r\n  font-size: 11px;\r\n  color: #9a9a9a;\r\n  margin-top: 4px;\r\n}\r\n\r\n.competitive-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.add-competitor-box {\r\n  width: 100%;\r\n  max-width: 350px;\r\n  border: 1px dashed #9fb6d7 !important;\r\n  color: #2C68AD !important;\r\n  background: #fff !important;\r\n  border-radius: 6px;\r\n  height: 32px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.add-competitor-box:hover {\r\n  background: #f1f6ff !important;\r\n}\r\n\r\n.social-icon{\r\n  width:36px;\r\n  height:36px;\r\n}\r\n\r\n// competitor analysis report\r\n.report-container {\r\n  padding: 12px 8px 32px;\r\n  width: 100%;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n}\r\n\r\n.report-header {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin-bottom: 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.report-back-button {\r\n  background-color: #2C68AD;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  font-weight: 600;\r\n  height: 32px;\r\n  justify-content: left;\r\n}\r\n\r\n.report-back-button:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.report-title {\r\n  font-size: 26px;\r\n  font-weight: 700;\r\n  font-family: 'opensans', sans-serif;\r\n  color: #000000;\r\n  margin: 0;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.report-card {\r\n  width: 100%;\r\n  min-width: 0;\r\n  border: 1px solid rgba(44, 104, 173, 0.2);\r\n  border-radius: 8px;\r\n  box-shadow: none;\r\n\r\n  .ant-card-body {\r\n    padding: 20px 22px;\r\n  }\r\n}\r\n\r\n.report-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #e6eef9;\r\n}\r\n\r\n.report-card-header h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #2C68AD;\r\n  font-family: 'opensans', sans-serif;\r\n}\r\n\r\n.report-actions {\r\n  display: inline-flex;\r\n  gap: 16px;\r\n}\r\n\r\n.report-icon-button {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  background: #fff;\r\n  color: #2C68AD;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n.report-icon{\r\n  width:20px;\r\n  height:20px;\r\n}\r\n.report-section {\r\n  border: 1px solid #e6eef9;\r\n  border-radius: 6px;\r\n  padding: 16px 18px;\r\n  margin-bottom: 12px;\r\n  background: #fff;\r\n}\r\n\r\n.report-section-sources {\r\n  padding: 24px 20px 32px;\r\n}\r\n\r\n.report-section-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #000000;\r\n  font-family: 'opensans', sans-serif;\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.sentiment-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.sentiment-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 2px solid #2C68AD;\r\n  color: #2C68AD;\r\n  font-size: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sentiment-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sentiment-stat {\r\n  text-align: center;\r\n}\r\n\r\n.sentiment-value {\r\n  font-size: 20px;\r\n  font-weight: 800;\r\n  color: #000000;\r\n  display: block;\r\n}\r\n\r\n.sentiment-inline-pct {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  margin-left: 4px;\r\n}\r\n\r\n.sentiment-label {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: #6E6A6A;\r\n  display: block;\r\n  margin-top: 2px;\r\n}\r\n\r\n.sentiment-total .sentiment-value {\r\n  color: #000000;\r\n}\r\n\r\n.sentiment-sublabel {\r\n  font-size: 11px;\r\n  color: #6e6a6a;\r\n  margin-top: 2px;\r\n  font-family: 'opensans', sans-serif;\r\n}\r\n\r\n.sentiment-positive .sentiment-value,\r\n.sentiment-positive .sentiment-inline-pct {\r\n  color: #2e7d32;\r\n}\r\n\r\n.sentiment-neutral .sentiment-value,\r\n.sentiment-neutral .sentiment-inline-pct {\r\n  color: #f9a825;\r\n}\r\n\r\n.sentiment-negative .sentiment-value,\r\n.sentiment-negative .sentiment-inline-pct {\r\n  color: #d32f2f;\r\n}\r\n\r\n.sentiment-bar {\r\n  display: flex;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: #e6eef9;\r\n  width: 100%;\r\n  margin-top: 4px;\r\n}\r\n\r\n.sentiment-segment {\r\n  height: 100%;\r\n  display: block;\r\n  min-width: 6px;\r\n}\r\n\r\n.sentiment-segment.positive {\r\n  background: #37A751;\r\n}\r\n\r\n.sentiment-segment.neutral {\r\n  background: #FFBA03;\r\n}\r\n\r\n.sentiment-segment.negative {\r\n  background: #FF0000;\r\n}\r\n\r\n.source-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.source-list-empty,\r\n.report-section-empty {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #6e6a6a;\r\n  font-family: 'opensans', sans-serif;\r\n}\r\n\r\n.source-accordion {\r\n  border-bottom: 1px solid #e6eef9;\r\n\r\n  &.is-expanded {\r\n    background: #fff;\r\n  }\r\n}\r\n\r\n.source-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  min-height: 86px;\r\n  padding: 16px 0 16px 22px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  gap: 24px;\r\n}\r\n\r\n.source-platform {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 74px;\r\n  min-width: 74px;\r\n  gap: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #000000;\r\n  margin-left: 0;\r\n}\r\n\r\n.source-platform img {\r\n  width: 46px;\r\n  height: 46px;\r\n  object-fit: contain;\r\n}\r\n\r\n.source-platform > span:not(.source-reddit-icon) {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n}\r\n\r\n.source-reddit-icon {\r\n  width: 46px;\r\n  height: 46px;\r\n  border-radius: 6px;\r\n  background: #ff4500;\r\n  color: #fff;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 34px;\r\n  line-height: 1;\r\n}\r\n\r\n.source-metrics {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  flex-wrap: nowrap;\r\n  gap: 34px;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  color: #000000;\r\n  margin-right: 0;\r\n  margin-left: auto;\r\n  white-space: nowrap;\r\n}\r\n\r\n.source-metrics .positive {\r\n  color: #37A751;\r\n  font-weight: 500;\r\n}\r\n\r\n.source-metrics .negative {\r\n  color: #FF0000;\r\n  font-weight: 500;\r\n}\r\n\r\n.source-chevron {\r\n  color: #707a85;\r\n  flex-shrink: 0;\r\n  transition: transform 0.2s ease;\r\n  margin-right: 0;\r\n\r\n  &.is-open {\r\n    transform: rotate(180deg);\r\n  }\r\n}\r\n\r\n.source-posts-panel {\r\n  margin: 0 0 34px;\r\n  padding: 24px 26px 26px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #f8fafc;\r\n}\r\n\r\n.source-posts-panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 22px;\r\n\r\n  h4 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n    line-height: 1.3;\r\n    font-weight: 700;\r\n    color: #2f3a4c;\r\n    font-family: 'opensans', sans-serif;\r\n  }\r\n}\r\n\r\n.source-posts-search {\r\n  width: 100%;\r\n  max-width: 280px;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  background: #fff;\r\n}\r\n\r\n.source-posts-search-icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.source-posts-empty {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #6e6a6a;\r\n}\r\n\r\n.source-posts-table-wrap {\r\n  overflow-x: auto;\r\n  background: #fff;\r\n  border: 1px solid #e8eef6;\r\n  border-radius: 6px;\r\n}\r\n\r\n.source-posts-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-family: 'opensans', sans-serif;\r\n  table-layout: fixed;\r\n\r\n  tbody {\r\n    align-items: initial;\r\n    justify-content: initial;\r\n  }\r\n\r\n  tr {\r\n    width: 100%;\r\n    background: #fff !important;\r\n    border-radius: 0;\r\n  }\r\n\r\n  tbody tr:nth-child(odd),\r\n  tbody tr:nth-child(even) {\r\n    background: #fff !important;\r\n  }\r\n\r\n  tbody tr:not(:last-child) {\r\n    border-bottom: 1px solid #edf2f8 !important;\r\n  }\r\n\r\n  th {\r\n    text-align: left;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    color: #728096;\r\n    letter-spacing: 0.04em;\r\n    text-transform: uppercase;\r\n    padding: 18px 22px;\r\n    border-bottom: 1px solid #edf2f8 !important;\r\n  }\r\n\r\n  th:nth-child(1),\r\n  td:nth-child(1) {\r\n    width: 40%;\r\n  }\r\n\r\n  th:nth-child(2),\r\n  td:nth-child(2) {\r\n    width: 15%;\r\n  }\r\n\r\n  th:nth-child(3),\r\n  td:nth-child(3) {\r\n    width: 27%;\r\n  }\r\n\r\n  th:nth-child(4),\r\n  td:nth-child(4) {\r\n    width: 18%;\r\n    vertical-align: middle;\r\n    text-align: center !important;\r\n  }\r\n\r\n  td {\r\n    text-align: left !important;\r\n    font-size: 13px;\r\n    color: #2f3a4c;\r\n    padding: 21px 22px;\r\n    border-bottom: 1px solid #edf2f8;\r\n    vertical-align: top;\r\n    word-break: break-word;\r\n    background: #fff !important;\r\n  }\r\n\r\n  tbody tr:last-child td {\r\n    border-bottom: none !important;\r\n  }\r\n}\r\n\r\n.source-post-details a {\r\n  display: inline-block;\r\n  text-align: left;\r\n  color: #2f74ff;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  line-height: 1.55;\r\n\r\n  &:hover {\r\n    text-decoration: underline;\r\n  }\r\n}\r\n\r\n.source-post-type {\r\n  display: inline-block;\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  background: #eef4ff;\r\n  color: #2c68ad;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.source-post-comments {\r\n  // td — keep as table-cell, use inner div for flex layout\r\n}\r\n\r\n.source-post-comments-inner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 13px;\r\n}\r\n\r\n.source-post-comment {\r\n  display: block;\r\n  color: #2f3a4c;\r\n  line-height: 1.4;\r\n}\r\n\r\n.source-post-engagement {\r\n  // td — keep as table-cell, vertical-align set via nth-child selector above\r\n}\r\n\r\n.source-post-engagement-inner {\r\n  display: inline-flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  color: #2f3a4c;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n\r\n  svg {\r\n    color: #e53935;\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n.source-post-likes-value {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 14px;\r\n  color: #2f3a4c;\r\n}\r\n\r\n.source-post-likes-label {\r\n  color: #96a1b2;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.source-posts-pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 18px 22px;\r\n  margin-top: 0;\r\n  font-size: 12px;\r\n  color: #728096;\r\n  background: #fff;\r\n}\r\n\r\n.source-posts-pagination-summary {\r\n  margin-right: auto;\r\n  font-size: 11px;\r\n\r\n  strong {\r\n    font-weight: 700;\r\n    color: #445066;\r\n  }\r\n}\r\n\r\n.source-posts-pagination-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.source-posts-page-indicator {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  padding: 0 8px;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #445066;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.source-posts-page-btn {\r\n  border: 1px solid #d5e3f5;\r\n  background: #fff;\r\n  color: #2c68ad;\r\n  border-radius: 8px;\r\n  min-width: 34px;\r\n  height: 34px;\r\n  padding: 0 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n\r\n  &:disabled {\r\n    opacity: 0.45;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n.report-summary-box {\r\n  background: #f4f8ff;\r\n  border: 1px solid #e6eef9;\r\n  border-left: 4px solid #2c68ad;\r\n  border-radius: 4px;\r\n  padding: 14px 16px;\r\n\r\n  p {\r\n    margin: 0 0 10px;\r\n    font-size: 13px;\r\n    line-height: 1.6;\r\n    color: #111;\r\n    font-family: 'opensans', sans-serif;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.report-highlights-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 14px 16px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.report-highlight-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  background: #f5faff;\r\n  border: 1px solid #d8eaff;\r\n  border-radius: 8px;\r\n  padding: 17px 16px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: #53647a;\r\n  font-family: 'opensans', sans-serif;\r\n}\r\n\r\n.report-highlight-arrow {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50%;\r\n  background: #e3f1ff;\r\n  color: #2f7bd7;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.report-highlight-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  color: #53647a;\r\n}\r\n\r\n.report-markdown {\r\n  font-size: 13px;\r\n  line-height: 1.55;\r\n  color: #111;\r\n  font-family: 'opensans', sans-serif;\r\n\r\n  p,\r\n  .report-markdown-paragraph {\r\n    margin: 0 0 8px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .report-markdown-heading {\r\n    margin: 10px 0 6px;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    color: #2c68ad;\r\n    font-family: 'opensans', sans-serif;\r\n\r\n    &:first-child {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  .report-markdown-list {\r\n    margin: 0 0 8px;\r\n    padding-left: 18px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .report-markdown-list-item {\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  strong {\r\n    font-weight: 700;\r\n    color: #111;\r\n  }\r\n}\r\n\r\n.report-markdown-link {\r\n  color: #2c68ad;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n}\r\n\r\n.report-summary-box .report-markdown .report-markdown-heading {\r\n  font-size: 12px;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.report-highlight-content .report-markdown p {\r\n  display: inline;\r\n  margin: 0;\r\n}\r\n\r\n.report-highlight-content .report-markdown {\r\n  color: #53647a;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  line-height: 1.55;\r\n}\r\n\r\n.report-actions-list .report-markdown p {\r\n  display: inline;\r\n  margin: 0;\r\n}\r\n\r\n.report-actions-list {\r\n  margin: 0;\r\n  padding-left: 18px;\r\n  font-size: 13px;\r\n  line-height: 1.6;\r\n  color: #111;\r\n  font-family: 'opensans', sans-serif;\r\n\r\n  li {\r\n    margin-bottom: 8px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.report-title-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  color: #2c68ad;\r\n  flex-shrink: 0;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .report-section-sources {\r\n    padding: 18px 12px 24px;\r\n  }\r\n\r\n  .source-row {\r\n    padding-left: 0;\r\n    gap: 12px;\r\n  }\r\n\r\n  .source-platform {\r\n    width: 58px;\r\n    min-width: 58px;\r\n  }\r\n\r\n  .source-platform img,\r\n  .source-reddit-icon {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n\r\n  .source-reddit-icon {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .source-metrics {\r\n    gap: 12px;\r\n    font-size: 13px;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .source-posts-panel {\r\n    padding: 18px 14px;\r\n  }\r\n\r\n  .source-posts-panel-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .source-posts-search {\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
